import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BODY_PARTS } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
export function BodyBenefits() {
  const [active, setActive] = useState(BODY_PARTS[2].key);
  const current = BODY_PARTS.find(b => b.key === active)!;
  return <Section className="bg-forest-deep py-16 text-ivory md:py-20 rounded-[2.5rem]" data-id="element-29" data-mp="2k0g2ne2h0oo">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-30" data-mp="z7n5w2gmxkt5">
        <Eyebrow data-id="element-31" data-mp="u9lorn2rrvkb">Why Your Body Needs It</Eyebrow>
        <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-ivory sm:text-4xl lg:text-[2.75rem]" data-id="element-32" data-mp="uawsxo04n5by">
          Whole-body nourishment, every morning
        </h2>
        <p className="mt-4 text-base text-ivory/70" data-id="element-33" data-mp="l9q9b626leeh">
          One ritual that supports you from head to toe. Select an area to learn more.
        </p>
      </Reveal>

      <div className="mt-14 grid items-center gap-10 lg:grid-cols-2" data-id="element-34" data-mp="35z5xrudxgr0y">
        <Reveal className="flex flex-wrap justify-center gap-3" data-id="element-35" data-mp="35xutltgklh9b">
          {BODY_PARTS.map(b => <button key={b.key} onClick={() => setActive(b.key)} className={`rounded-full border px-5 py-2.5 text-sm font-medium transition-all ${active === b.key ? 'border-ivory bg-ivory text-forest' : 'border-ivory/25 text-ivory/80 hover:border-ivory/60'}`} data-id="element-36" data-mp="w7gz2aufvw6a">
              {b.label}
            </button>)}
        </Reveal>

        <Reveal delay={0.1} data-id="element-37" data-mp="ia28v3wd3kd9">
          <AnimatePresence mode="wait" data-id="element-38" data-mp="ib3h70lztsra">
            <motion.div key={active} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.4
          }} className="rounded-2xl border border-ivory/15 bg-forest/40 p-8" data-id="element-39" data-mp="4inl6jrieuzv">
              <span className="text-xs font-medium uppercase tracking-[0.28em] text-sage" data-id="element-40" data-mp="3voyhk2lkr7kv">
                Supports
              </span>
              <h3 className="mt-3 font-serif text-3xl text-ivory" data-id="element-41" data-mp="219roq0yg2pd1">{current.label}</h3>
              <p className="mt-4 text-lg leading-relaxed text-ivory/80" data-id="element-42" data-mp="1wg6yiv33ezoe">{current.desc}</p>
            </motion.div>
          </AnimatePresence>
        </Reveal>
      </div>
    </Section>;
}